
const PUBLIC_ROUTE_URL = `${process.env.PUBLIC_URL}`;
export const ROUTES = {
    ADMINLOGINPAGE: PUBLIC_ROUTE_URL + "/",
    FORGOTPASSWORD: PUBLIC_ROUTE_URL + "/forget-password",
    RESETPASSWORD: PUBLIC_ROUTE_URL + "/reset-password",
    SIDEBAR: PUBLIC_ROUTE_URL + '/sidebar',
    LEFTBAR: PUBLIC_ROUTE_URL + '/leftbar',
    TOPBAR: PUBLIC_ROUTE_URL + '/topbar',
    DASHBOARD: PUBLIC_ROUTE_URL + "/dashboard",
    ADMINROLE: PUBLIC_ROUTE_URL + "/teamrole-access",
    MODALTABLE: PUBLIC_ROUTE_URL + "/modal-management",
    DIMENSIONTABLE: PUBLIC_ROUTE_URL + "/dimenstion-management",
    SUBDIMENSIONTABLE: PUBLIC_ROUTE_URL + "/subdimenstion-management",
    CRITERIATABLE: PUBLIC_ROUTE_URL + "/criteria-management",
    BULKUPLOAD: PUBLIC_ROUTE_URL + "/bulk-upload",
    EMPLOYEEMANAGEMENT: PUBLIC_ROUTE_URL + "/teamemployee-management",
    ADDROLE: PUBLIC_ROUTE_URL + "/Add-Role",
    ADDEMPLOYEE: PUBLIC_ROUTE_URL + "/add-employee",
    ADDCRITERIA: PUBLIC_ROUTE_URL + "/add-criteria",
    MODEL: PUBLIC_ROUTE_URL + "/Model",
    COMPANYMANAGEMENT: PUBLIC_ROUTE_URL + "/comapny-management",
    COMPANYEMPLOYEEMANAGEMENT: PUBLIC_ROUTE_URL + "/company-employee-managemnet",
    ADDCOMPANYEMLOYEE: PUBLIC_ROUTE_URL + "/addcompany-employee-managemnet",
    ADDCOMPANY: PUBLIC_ROUTE_URL + "/addcompany-managemnet",
    ONSITE: PUBLIC_ROUTE_URL + "/assessor-list",
    ADDONSITE: PUBLIC_ROUTE_URL + "/addonsite-managemnet",
    INDIVISUALRESULT: PUBLIC_ROUTE_URL + "/indivisual-result",
    INDIVISUALRESULTNEW: PUBLIC_ROUTE_URL + "/indivisual-result-new",
    OVERALLRESULT: PUBLIC_ROUTE_URL + "/overall-result",
    NEWRESULT: PUBLIC_ROUTE_URL + "/new-result",
    GRAPHDETAIL: PUBLIC_ROUTE_URL + "/graph-detail",
    ADMINPROFILE: PUBLIC_ROUTE_URL + "/admin-profile",
    ADMINCHANGEPASSWORD: PUBLIC_ROUTE_URL + "/admin-changepassword",
    ONSITESCORE: PUBLIC_ROUTE_URL + "/on-site-assessment",
    ADDASSIGNEDASSESSMENTS: PUBLIC_ROUTE_URL + "/addAssigned-assesments",
    VIEWASSIGNEDASSESSMENTS: PUBLIC_ROUTE_URL + "/viewAssigned-assessments",
    VIEWASSIGNEDEBYCOMPNYID: PUBLIC_ROUTE_URL + "/viewEmployeebyCompany",
    VIEWUSERWISERESULT: PUBLIC_ROUTE_URL + "/organization-Wise-user-result",
    FIRSTTIMECHANGESPASS: PUBLIC_ROUTE_URL + "/change-password",
    EMPLOYEEBULKUPLOAD:PUBLIC_ROUTE_URL +"/employee-bulk-upload",
    ASSESSORMANAGEMENT:PUBLIC_ROUTE_URL +"/assessor-management",
    ADDASSESSORMANAGEMENT:PUBLIC_ROUTE_URL +"/assessor"
    
}